import {useHistory, useLocation} from "react-router-dom";
import "../../sass/main.scss";
import React, {useEffect, useRef, useState} from "react";
import Fn from "../../libraries/Fn";
import $ from 'jquery';
import axios2 from "../../helpers/APIHelper";

import introLogo from '../../images/intro_logo.png';
import introThum from '../../images/icon_user.png'; // Ensure path is correct
// import Modal from "react-modal";
import Constants from "../../constants/constants";

import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import logoPro from "../../images/logo_pro.png";
import logoFitness from "../../images/logo_fitness.png";
import logoGym from "../../images/logo_gym.png";
import logoFa from "../../images/logo_fa.png";
import logoX2 from "../../images/logo_x2.png";
import logoHealthymeal from "../../images/logo_healthymeal.png";
import member_thumb from "../../images/member_thumb.png";
import img_0011_w from "../../images/0011_w.png";
import img_0018_w from "../../images/0018_w.png";
import img_0020_w from "../../images/0020_w.png";
import img_0022_w from "../../images/0022_w.png";

import _introThum from '../../images/enter/intro_thum.png';
import introIcon01 from '../../images/enter/intro_icon01.png';
import introIcon02 from '../../images/enter/intro_icon02.png';
import introIcon03 from '../../images/enter/intro_icon03.png';
import introIcon01off from '../../images/enter/intro_icon01off.png';
import introIcon02off from '../../images/enter/intro_icon02off.png';
import introIcon03off from '../../images/enter/intro_icon03off.png';
import introLogoW from '../../images/enter/intro_logo_w.png';

// TODO : PTODO => alim (알림 삭제) 처리 필요
const Main = (props) => {

  window._load = (_page = 1) => {
    try {
      load(_page);
    } catch (e) {
    }
  }
  const history = useHistory();
  const location = useLocation();

  const [cardNum, setCardNum] = useState(location?.state?.cardNum || '');
  const [result, setResult] = useState();
  const [audioFile, setAudioFile] = useState();
  // 멤버십 타입 상태 추가
  const [membershipType, setMembershipType] = useState('');

  useEffect(() => {
    // $('body').css('overflow', 'hidden');
    // Fn.resizeScreenReal(1.1);
    // $(window).bind('resize', function () {
    //   localStorage.setItem("intro_resized", "1");
    //   Fn.resizeScreen(1.1);
    // })
    return () => {
      try {
        clearTimeout(window.backTimeout);
      } catch (err) {
      }
      // $(window).unbind('resize');
    };
  }, []);

  var maskName = function (strName) {
    if (!strName) return "";
    if (strName.length > 2) {
      var originName = strName.split('');
      originName.forEach(function (name, i) {
        if (i === 0 || i === originName.length - 1) return;
        originName[i] = '*';
      });
      var joinName = originName.join();
      return joinName.replace(/,/g, '');
    } else {
      var pattern = /.$/; // 정규식
      return strName.replace(pattern, '*');
    }
  };

  /*
  useEffect(() => {
    axios2
      .post(`/common/update/check?build=${Constants.BUILD}`)
      .then((response) => {
        const {code, message, result, pageInfo} = response?.data;
        if (code === 200) {
          if (message === 'update') {
            window.location.reload();
          }
        }
      })
      .catch((error) => {
      });
  }, [window.location.pathname]);
  */

  useEffect(() => {
    if (Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) <= 0) {
      history.push("/login");
      return;
    }

    $.ajaxSetup({
      beforeSend: function (xhr, options) {
        if (options.url.startsWith(":3000"))
          options.url = options.url.replace(":3000", ":8994");
        else if (options.url.indexOf("http") === -1)
          options.url = Constants.API_URL + options.url;
      },
      headers: {
        'Authorization': ('Bearer ' + localStorage.getItem("USER.token"))
      },
      cache: false,
      error: function (jqXHR, textStatus, errorThrown) {
        Fn.parseAjaxError(jqXHR, textStatus, errorThrown, history);
      }
    });

    $('.main_wrapper').height($(document).height());
  }, []);

  useEffect(() => {
    $('body').css('zoom', 'unset');
    $('#_INTRO_BG2').height($(document).height());
    $("*").each(function () {
      $(this).css({"outline": "none", "lineHeight": "180%"});
    });
  }, []);

  useEffect(() => {
    clearTimeout(window.backTimeout);
    $('#cardNum').focus().select();
    load();
  }, [cardNum]);

  const load = () => {
    $('#overlay').show();

    axios2
      .post(`/enter/enter?cardNum=${cardNum}`)
      .then((response) => {
        const {code, message, result} = response?.data;
        console.log(result);
        setResult(result);
        if (code === 200) {
          if (Fn.parseInt(result.err_type) === 1) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file2)));
            $('#err_title').html('미인증 회원');
            $('#err_cont').html('등록되지 않은 회원번호입니다<br/>자세한 사항은 관리자에게 문의바랍니다.');
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 80) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file2)));
            $('#err_title').html('카드 읽기 오류');
            $('#err_cont').html('리더기에 카드를 다시 읽어주세요<br/>자세한 사항은 관리자에게 문의바랍니다.');
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 2) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file2)));
            $('#err_title').html('기간 만료');
            if (result.end_date)
              $('#err_cont').html(`이용기간이 종료된 회원입니다.<br/>종료일 : ${result.end_date}<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            else
              $('#err_cont').html(`이용기간이 종료된 회원입니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 3) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file4)));
            $('#err_title').html('휴회기간 입장');
            // TODO
            // $('#err_cont').html(`회원님은 현재 휴회기간중입니다.<br/>휴회기간 : ${result.de_sDate} ~ ${result.de_eDate}<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('#err_cont').html(`회원님은 현재 휴회기간중입니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 4) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file5)));
            $('#err_title').html('미납회원');
            $('#err_cont').html(`미납요금 ${Fn.numberWithCommas(result?.misu_price)}이 있습니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 5) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file3)));
            $('#err_title').html('기출석 회원');
            $('#err_cont').html(`금일 출석이력이 존재합니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 8) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file2)));
            $('#err_title').html('유효시간 초과');
            $('#err_cont').html(`생성된 바코드의 유효시간이 초과되었습니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 9) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file6)));
            $('#err_title').html('이용불가 지점');
            $('#err_cont').html(`회원님의 입장이 불가능한 지점입니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 91) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file6)));
            $('#err_title').html('이용불가 지점');
            $('#err_cont').html(result?.err_msg ? result?.err_msg?.replace("\n", "<br/>") : `BASIC 상품으로 입장이 불가능한 지점입니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 10) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file2)));
            $('#err_title').html('이용요일 불가');
            $('#err_cont').html(`금일은 회원님의 입장이 불가능한 요일입니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 11) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file2)));
            $('#err_title').html('이용시간 불가');
            $('#err_cont').html(`금일은 회원님의 입장이 불가능한 시간입니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 12) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file2)));
            $('#err_title').html('타지점 이용불가');
            $('#err_cont').html(`타지점 이용이 불가합니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 13) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file2)));
            $('#err_title').html('이용불가 시간');
            $('#err_cont').html(result?.err_msg || `현재는 운영시간이 아닙니다.<br/>자세한 사항은 관리자에게 문의바랍니다.`);
            $('.pop_background').show();
          } else if (Fn.parseInt(result.err_type) === 90) {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file1)));
            $('#err_title').html(`${result.branch_name} 지점`);
            $('#err_cont').html(`${result.step_name} 스텝 바코드 입장입니다.`);
            $('.pop_background').show();
          } else {
            setAudioFile(Fn.makeUrl(Constants.API_URL + "/common/download?cd=attachment&type=sound_files&filename=" + encodeURIComponent(result?.s_file1)));
          }
        }

        try {
          const ocare_send = result?.ocare_send || "";
          if (ocare_send) {
            $.ajax({
              type: "post",
              url: `https://smms.spoany.co.kr/kiosk/enter_ocare.php?member_id=${ocare_send?.split(",")?.[0]}&branch_code=${ocare_send?.split(",")?.[1]}&branch_name=${encodeURIComponent(ocare_send?.split(",")?.[2])}`,
              success: function (data) {
                data = data.trim();
                console.log('OCARE', data);
              },
              error: function (e) {
                //alert('데이터오류! 시스템 관리자에게 문의하세요');
              }
            });
          }
        } catch (err) {
        }

        clearTimeout(window.backTimeout);
        window.backTimeout = setTimeout(() => {
          try {
            clearTimeout(window.backTimeout);
          } catch (err) {
          }
          // 수정
          history.push("/enter/enter");
        }, 6000)
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      })
      .finally(() => {
        $('#overlay').fadeOut(300);
      });
  }

  useEffect(() => {
    return () => {
      clearTimeout(window.backTimeout);
    }
  }, []);

  if (false) {
    // 사용하지 않는 코드 블록이므로 생략
    return null;
  } else {
    let logoSrc;
    switch (localStorage.getItem("USER.systemBrand")) {
      case 'P':
        logoSrc = logoPro;
        break;
      case 'F':
        logoSrc = logoFitness;
        break;
      case 'G':
        logoSrc = logoGym;
        break;
      case 'S':
        logoSrc = logoFa;
        break;
      case 'X':
        logoSrc = logoX2;
        break;
      case 'M':
        logoSrc = logoHealthymeal;
        break;
      default:
        logoSrc = logoFitness;
    }

    // 멤버십 타입에 따른 클래스 설정
    const themeClass = result?.isAnyPASS === 1 ? 'anypass' : result?.isBASIC === 1 ? 'basic' : '';

    return (
      <div id="_INTRO_BG2" className={themeClass}>
        <div className="_intro_wrap">
          <div className="p_absolute_mid2">
            <div className="d-flex justify-content-between my-2">
              <div className="d-flex justify-content-center" style={{alignItems: "center"}}>
                <p><img src={logoSrc} style={{height: "62px"}}/></p>
                <p className="h5 bold800 mb-0 px-1 text-gray" style={{marginLeft: "10px", marginTop: "10px"}}>{localStorage.getItem("USER.systemBranchName")}</p>
              </div>

              <p className="mt-2">
                <input type="text" style={{width: "280px", height: "50px", verticalAlign: "-2px"}} placeholder="회원 카드번호 입력" name="cardNum" id="cardNum" className="enter-cardnum"
                       onKeyDown={(e) => {
                         if (e.keyCode == 13) {
                           if (!$('#cardNum')?.val()?.trim()) return;
                           if ($('#cardNum').val().length < 6) return;

                           setCardNum($('#cardNum').val());
                           $('#cardNum').val('').focus();
                         }
                       }}
                />
                <button type="button" className={`btn btn-point ${themeClass}`} style={{width: "80px", height: "50px"}} onClick={() => {
                  if (!$('#cardNum')?.val()?.trim()) return;
                  if ($('#cardNum').val().length < 6) return;

                  setCardNum($('#cardNum').val());
                  $('#cardNum').val('').focus();
                }}>
                  <span className="h6 bold700">검색</span>
                </button>
              </p>
            </div>

            <div className={`_intro_box ${themeClass}`} style={{width: "1140px", minHeight: "500px"}}>
              <div className="d-flex pt-5 px-5 _intro_box_in">
                <div className="d-flex" style={{flex: 2, textAlign: "left"}}>
                  <p className="_intro_usr_thum"><img src={introThum}/></p>
                  <p className="px-3 py-3 text-white" style={{marginTop: "-22px"}}>
                    <span className={`h1 bold700 ${(result?.isAnyPASS || result?.isBASIC) ? 'text-real-black' : 'bold700'}`}>{maskName(result?.mb_name)}님</span><br/>
                    <span className="h4 bold700">{result?.member_grade === 'F' ? '피트니스' : result?.member_grade === 'P' ? '프로' : result?.member_grade === 'G' ? '짐' : result?.member_grade === 'S' ? '패스트' : ''}</span>
                  </p>
                </div>
                <p className={`mx-3 px-4 h6 bold800 my-4 _intro_box2 ${themeClass}`}>출석률&nbsp;&nbsp;&nbsp;<span className={`h6 bold800 text-black ${themeClass}`}>{result?.per2 > 100 ? 100 : result?.per2 || 0} %</span></p>
                <p className={`px-4 h6 bold800 my-4 _intro_box2 ${themeClass}`}>포인트&nbsp;&nbsp;&nbsp;<span className={`h6 bold800 text-black ${themeClass}`}>{Fn.numberWithCommas(result?.mb_point || 0)}P</span></p>
              </div>

              <div className="d-flex justify-content-between px-5 pt-4 mt-2">
                <p className="h5 bold100 mb-0 px-1 text-white">이번달 <span className={`h5 bold800 text-black ${themeClass}`}>{isNaN(result?.ct + result?.ctTar) ? "0" : (result?.ct + result?.ctTar)}</span>번째 출석</p>
                <p className="h2 bold800 mb-0 px-1 text-gray2" style={{marginTop: "-15px"}}>
                  {result?.d_day < 0 ? "D+" : "D-"}
                  {result?.d_day < 0 ?
                    <span className={`h2 bold800 text-black ${themeClass}`}>{Math.abs(result?.d_day || 0)}</span>
                    :
                    <span className={`h2 bold800 text-black ${themeClass}`}>{result?.d_day || 0}</span>
                  }
                </p>
              </div>

              <div className="mx-5 my-3 _intro_progress_bg">
                {/*<p className="_intro_progress_point"></p>*/}
                <div className={`_intro_progress_bar ${themeClass}`} style={{width: (result?.per > 100) ? "100%" : `${result?.per}%`}}></div>
              </div>

              <div className="d-flex justify-content-between px-5 ">
                <p className={`px-1 ${(result?.isAnyPASS || result?.isBASIC) ? 'text-real-black' : 'text-gray'}`} style={{fontSize: "18px", fontWeight: "bold", letterSpacing: "-1px"}}>
                  출석 : {result?.branch_name} {result?.ct}회 / 타지점 {result?.ctTar}회
                </p>
                <p className={`px-1 ${(result?.isAnyPASS || result?.isBASIC) ? 'text-real-black' : 'text-gray'}`} style={{fontSize: "18px", fontWeight: "bold", letterSpacing: "-1px"}}>회원기간 만료
                  : {result?.end_date?.split("-")?.[0]}년 {result?.end_date?.split("-")?.[1]}월 {result?.end_date?.split("-")?.[2]}일</p>
              </div>

              <div className="d-flex mt-4 px-5" style={{gap: "20px"}}>
                <div className={`d-flex justify-content-between ${result?.suit_end_date >= Fn.getCurrentDate() ? `_intro_box3_on ${themeClass}` : '_intro_box3_off'}`}>
                  <div className="m-4 px-2"><img src={result?.suit_end_date >= Fn.getCurrentDate() ? introIcon01 : introIcon01off} style={{width: "48px"}}/></div>
                  <div className="my-3 mx-2" style={{textAlign: "right"}}>
                    <p className="px-4 h6 bold800 text-real-white">운동복</p>
                    <p className={`m-0 px-4 h4 bold800 ${result?.suit_end_date >= Fn.getCurrentDate() ? `text-pink ${themeClass}` : "text-gray2"}`}>{result?.suit_end_date || "사용안함"}</p>
                  </div>
                </div>
                <div className={`d-flex justify-content-between ${result?.locker_end_date >= Fn.getCurrentDate() ? `_intro_box3_on ${themeClass}` : '_intro_box3_off'}`}>
                  <div className="m-4 px-2"><img src={result?.locker_end_date >= Fn.getCurrentDate() ? introIcon02 : introIcon02off} style={{width: "48px"}}/></div>
                  <div className="my-3 mx-2" style={{textAlign: "right"}}>
                    <p className="px-4 h6 bold800 text-real-white">라커</p>
                    <p className={`m-0 px-4 h4 bold800 ${result?.locker_end_date >= Fn.getCurrentDate() ? `text-pink ${themeClass}` : "text-gray2"}`}>{result?.locker_end_date || "사용안함"}</p>
                  </div>
                </div>
                <div className={`d-flex justify-content-between ${result?.pt_remain > 0 ? `_intro_box3_on ${themeClass}` : '_intro_box3_off'}`}>
                  <div className="m-4 px-2"><img src={result?.pt_remain > 0 ? introIcon03 : introIcon03off} style={{width: "35px"}}/></div>
                  <div className="my-3 mx-2" style={{textAlign: "right"}}>
                    <p className={`pr-4 h6 bold800 text-real-white`}>
                      PT
                    </p>
                    <p className={`m-0 px-4 h4 bold800 ${(result?.isAnyPASS || result?.isBASIC) ? `text-pink ${themeClass}` : "text-gray2"}`}>{result?.pt_remain || 0}회</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex mt-2" style={{gap: "10px"}}>
              <div className={`_intro_box4 ${themeClass}`}>
                <p className="text-gray2 text-left intro_in_head_title">이용정보</p>
                <div className="d-flex justify-content-between">
                  <p className="py-2 h7 bold700 text-white">가입일</p>
                  <p className={`p-2 h6 bold800 text-pink ${(result?.isAnyPASS || result?.isBASIC) ? 'text-black' : 'text-pink'}`}>
                    {result?.mb_open_date?.substring(0, 10)?.replace(/-/g, ".")}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="py-2 h7 bold700 text-white">시작일</p>
                  <p className={`p-2 h6 bold800 text-pink ${(result?.isAnyPASS || result?.isBASIC) ? 'text-black' : 'text-pink'}`}>
                    {result?.start_date?.substring(0, 10)?.replace(/-/g, ".")}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="py-2 h7 bold700 text-white">종료일</p>
                  <p className={`p-2 h6 bold800 text-pink ${(result?.isAnyPASS || result?.isBASIC) ? 'text-black' : 'text-pink'}`}>
                    {result?.end_date?.substring(0, 10)?.replace(/-/g, ".")}
                  </p>
                </div>
              </div>

              <div className={`_intro_box4 ${themeClass}`}>
                <p className="text-gray2 text-left intro_in_head_title">서비스내역</p>

                {result?.app_list_qry?.map((item, index) =>
                  <div className="d-flex justify-content-between" key={index}>
                    <p className="py-1 h7 bold700 text-white">{item?.ap_date?.substring(0, 10)?.replace(/-/g, ".")}</p>
                    <p className={`p-1 h7 bold700 ${(result?.isAnyPASS || result?.isBASIC) ? 'text-black' : 'text-white'}`}>
                      {item?.ap_pdtName || (item?.it_name || '')}
                    </p>
                  </div>
                )}
              </div>

              <div className={`_intro_box4 ${themeClass}`}>
                <p className="text-gray2 text-left intro_in_head_title">출석내역</p>

                {result?.l?.map((item, index) =>
                  <div className="d-flex justify-content-between" key={index}>
                    <p className={`py-1 h7 bold700 text-white`}>
                      {item?.ba_date?.replace(/-/g, ".") + " " + item?.ba_time}
                    </p>
                    <p className={`p-1 h7 bold700 ${(result?.isAnyPASS || result?.isBASIC) ? 'text-black' : 'text-white'}`}>
                      {item?.ba_gr_name}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="pop_background" style={{zIndex: 1000000000, display: "none"}}>
            <div className={`pop_box01 p_absolute_mid_pop_err text-center ${themeClass}`} style={{width: "500px", minHeight: "170px"}}>
              <h2 className="bold800" id="err_title"></h2>
              <h6 className="enter-modal-font bold500" id="err_cont" style={{marginTop: "20px"}}></h6>
            </div>
          </div>

        </div>

        <div style={{visibility: "hidden", position: "absolute", top: "-9999px"}}>
          {audioFile &&
            <AudioPlayer
              autoPlay
              src={audioFile}
              onPlay={e => console.log("onPlay")}
            />
          }
        </div>
      </div>
    );
  }
};

export default Main;
